export default __webpack_public_path__ + "static/enceinte2-a96dea195845f64719fbc295bc3d7782.jpg";